











import { SdsFlag } from '@superbet-group/web.lib.ui-components';
import { PropType } from '@vue/composition-api';
import Vue from 'vue';

Vue.component('SdsFlag', SdsFlag);

export default {
    name: 'StackedFlags',
    functional: true,
    props: {
        flags: {
            type: Array as PropType<string[]>,
            required: true,
        },
    },
};
